module.exports = __webpack_public_path__ + "img/179.73c852fe.jpg";